import * as React from "react";
import { Modal } from "../../../ui/components/Modal";
import type { ProductAccessTier } from "../../lib/api/product-access";
import { RequestProductAccessForm } from "./RequestProductAccessForm";

export function RequestProductAccessModal({
  open,
  setOpen,
  productName,
  currentTier,
  currentAccessTitle,
  initialTier,
  pending,
  pendingTier,
  submitting,
  cancelling,
  error,
  onSubmit,
  onCancelRequest,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  productName?: string | null;
  currentTier?: ProductAccessTier | null;
  currentAccessTitle?: string;
  initialTier?: ProductAccessTier;
  pending?: boolean;
  pendingTier?: ProductAccessTier | null;
  submitting?: boolean;
  cancelling?: boolean;
  error?: string | null;
  onSubmit: (tier: ProductAccessTier) => void | Promise<void>;
  onCancelRequest?: () => void | Promise<void>;
}) {
  return (
    <Modal open={open} setOpen={setOpen} minWidth="480px" maxWidth="520px" closeOnClickOff>
      <div style={{ padding: 8 }}>
        <RequestProductAccessForm
          mode="change"
          productName={productName}
          currentTier={currentTier}
          currentAccessTitle={currentAccessTitle}
          initialTier={initialTier}
          pending={pending}
          pendingTier={pendingTier}
          submitting={submitting}
          cancelling={cancelling}
          error={error}
          onCancel={() => setOpen(false)}
          onCancelRequest={onCancelRequest}
          onSubmit={onSubmit}
        />
      </div>
    </Modal>
  );
}
